import React from 'react';
import Icon from '../../../components/AppIcon';

const REVIEW_CHECKLIST = [
  { label: 'Identity document verification', icon: 'IdCard' },
  { label: 'Address proof validation', icon: 'MapPin' },
  { label: 'Social media handle verification', icon: 'Share2' },
  { label: 'Employment & income assessment', icon: 'Briefcase' },
];

const ELIGIBILITY_CHECKS = [
  { label: 'SocialCents Score assessment', icon: 'Star' },
  { label: 'Income verification', icon: 'DollarSign' },
  { label: 'Creator tier evaluation', icon: 'Award' },
  { label: 'Platform engagement analysis', icon: 'BarChart2' },
];

const StatusDetailPanel = ({ application }) => {
  const status = application?.status || 'pending';

  const refId = application?.id?.slice(0, 8)?.toUpperCase() || '—';

  const renderSubmitted = () => (
    <div className="space-y-4">
      <div
        className="flex items-start gap-3 p-4 rounded-xl"
        style={{ background: 'rgba(20,184,166,0.08)', border: '1px solid rgba(20,184,166,0.2)' }}
      >
        <Icon name="CheckCircle" size={16} color="#14B8A6" className="flex-shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-semibold" style={{ color: '#14B8A6', fontFamily: 'DM Sans, sans-serif' }}>Application Received</p>
          <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.5)', lineHeight: '1.5' }}>
            Your application has been successfully submitted and is now in our review queue. You'll receive email updates at each stage.
          </p>
        </div>
      </div>
      <div
        className="flex items-center gap-2 px-3 py-2 rounded-lg"
        style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)' }}
      >
        <Icon name="Hash" size={12} color="rgba(255,255,255,0.35)" />
        <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.4)' }}>Reference:</span>
        <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.75)', fontFamily: 'JetBrains Mono, monospace', fontWeight: 600 }}>{refId}</span>
      </div>
    </div>
  );

  const renderUnderReview = () => (
    <div className="space-y-4">
      <div
        className="flex items-start gap-3 p-4 rounded-xl"
        style={{ background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.2)' }}
      >
        <Icon name="Search" size={16} color="#f59e0b" className="flex-shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-semibold" style={{ color: '#f59e0b', fontFamily: 'DM Sans, sans-serif' }}>Under Active Review</p>
          <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.5)', lineHeight: '1.5' }}>
            Our compliance team is carefully reviewing your submitted documents and information.
          </p>
        </div>
      </div>
      <div>
        <p className="text-xs font-semibold mb-3" style={{ color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Review Checklist</p>
        <div className="space-y-2">
          {REVIEW_CHECKLIST?.map((item, i) => (
            <div key={i} className="flex items-center gap-3 py-2 px-3 rounded-lg" style={{ background: 'rgba(255,255,255,0.03)' }}>
              <div
                className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ background: 'rgba(245,158,11,0.12)', border: '1px solid rgba(245,158,11,0.25)' }}
              >
                <Icon name={item?.icon} size={11} color="#f59e0b" />
              </div>
              <span className="text-xs" style={{ color: 'rgba(255,255,255,0.6)' }}>{item?.label}</span>
              <div className="ml-auto">
                <div
                  className="w-4 h-4 rounded-full flex items-center justify-center"
                  style={{ background: 'rgba(245,158,11,0.15)', border: '1px solid rgba(245,158,11,0.3)' }}
                >
                  <div className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ background: '#f59e0b' }} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  const renderEligibility = () => (
    <div className="space-y-4">
      <div
        className="flex items-start gap-3 p-4 rounded-xl"
        style={{ background: 'rgba(139,92,246,0.08)', border: '1px solid rgba(139,92,246,0.2)' }}
      >
        <Icon name="ShieldCheck" size={16} color="#8b5cf6" className="flex-shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-semibold" style={{ color: '#8b5cf6', fontFamily: 'DM Sans, sans-serif' }}>Eligibility Assessment</p>
          <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.5)', lineHeight: '1.5' }}>
            We're evaluating your SocialCents Score, income, and creator tier to determine card eligibility.
          </p>
        </div>
      </div>
      <div>
        <p className="text-xs font-semibold mb-3" style={{ color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Eligibility Criteria</p>
        <div className="space-y-2">
          {ELIGIBILITY_CHECKS?.map((item, i) => (
            <div key={i} className="flex items-center gap-3 py-2 px-3 rounded-lg" style={{ background: 'rgba(255,255,255,0.03)' }}>
              <div
                className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
                style={{ background: 'rgba(139,92,246,0.12)', border: '1px solid rgba(139,92,246,0.25)' }}
              >
                <Icon name={item?.icon} size={11} color="#8b5cf6" />
              </div>
              <span className="text-xs" style={{ color: 'rgba(255,255,255,0.6)' }}>{item?.label}</span>
              <div className="ml-auto">
                <div
                  className="w-4 h-4 rounded-full flex items-center justify-center"
                  style={{ background: 'rgba(139,92,246,0.15)', border: '1px solid rgba(139,92,246,0.3)' }}
                >
                  <div className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ background: '#8b5cf6', animationDelay: `${i * 0.2}s` }} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {application?.sc_score !== undefined && (
        <div
          className="flex items-center justify-between p-3 rounded-xl"
          style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.07)' }}
        >
          <span className="text-xs" style={{ color: 'rgba(255,255,255,0.5)' }}>Your SocialCents Score</span>
          <span style={{ fontSize: '18px', fontWeight: 800, color: '#14B8A6', fontFamily: 'JetBrains Mono, monospace' }}>
            {application?.sc_score}
          </span>
        </div>
      )}
    </div>
  );

  const renderDecision = () => {
    if (status === 'approved') {
      return (
        <div className="space-y-4">
          <div
            className="flex items-start gap-3 p-4 rounded-xl"
            style={{ background: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.25)' }}
          >
            <Icon name="CheckCircle" size={16} color="#10b981" className="flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-semibold" style={{ color: '#10b981', fontFamily: 'DM Sans, sans-serif' }}>Application Approved!</p>
              <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.5)', lineHeight: '1.5' }}>
                Congratulations! Your SocialCents Card application has been approved. Your card will be issued within 5–7 business days.
              </p>
            </div>
          </div>
          <div
            className="p-4 rounded-xl space-y-2"
            style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)' }}
          >
            <div className="flex items-center gap-2">
              <Icon name="CreditCard" size={13} color="rgba(255,255,255,0.4)" />
              <span className="text-xs" style={{ color: 'rgba(255,255,255,0.5)' }}>Card issuance: <strong style={{ color: 'rgba(255,255,255,0.8)' }}>5–7 business days</strong></span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Mail" size={13} color="rgba(255,255,255,0.4)" />
              <span className="text-xs" style={{ color: 'rgba(255,255,255,0.5)' }}>Confirmation email sent to your registered address</span>
            </div>
          </div>
        </div>
      );
    }

    if (status === 'rejected') {
      return (
        <div className="space-y-4">
          <div
            className="flex items-start gap-3 p-4 rounded-xl"
            style={{ background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.25)' }}
          >
            <Icon name="XCircle" size={16} color="#ef4444" className="flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-semibold" style={{ color: '#ef4444', fontFamily: 'DM Sans, sans-serif' }}>Application Not Approved</p>
              <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.5)', lineHeight: '1.5' }}>
                Unfortunately your application did not meet our current eligibility criteria. You may re-apply after 30 days or update your documents.
              </p>
            </div>
          </div>
        </div>
      );
    }

    // Pending decision
    return (
      <div
        className="flex items-start gap-3 p-4 rounded-xl"
        style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}
      >
        <Icon name="Clock" size={16} color="rgba(255,255,255,0.4)" className="flex-shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-semibold" style={{ color: 'rgba(255,255,255,0.7)', fontFamily: 'DM Sans, sans-serif' }}>Decision Pending</p>
          <p className="text-xs mt-1" style={{ color: 'rgba(255,255,255,0.4)', lineHeight: '1.5' }}>
            A final decision will be communicated within 3–5 business days from submission.
          </p>
        </div>
      </div>
    );
  };

  const stageMap = {
    pending: { title: 'Submitted', render: renderSubmitted },
    submitted: { title: 'Submitted', render: renderSubmitted },
    under_review: { title: 'Under Review', render: renderUnderReview },
    eligibility: { title: 'Eligibility Check', render: renderEligibility },
    approved: { title: 'Decision', render: renderDecision },
    rejected: { title: 'Decision', render: renderDecision },
    decision: { title: 'Decision', render: renderDecision },
  };

  const current = stageMap?.[status] || stageMap?.pending;

  return (
    <div
      className="rounded-2xl p-6"
      style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)' }}
    >
      <div className="flex items-center gap-2 mb-5">
        <div
          className="w-7 h-7 rounded-lg flex items-center justify-center"
          style={{ background: 'linear-gradient(135deg,#0d9488,#1d4ed8)' }}
        >
          <Icon name="Info" size={13} color="#fff" />
        </div>
        <h2 className="text-sm font-semibold text-white" style={{ fontFamily: 'DM Sans, sans-serif' }}>Stage Details — {current?.title}</h2>
      </div>
      {current?.render()}
    </div>
  );
};

export default StatusDetailPanel;
